import { DC } from "../constants";

export const catchupResources = [
  {
    name: "Antimatter Dimensions",
    textName: "Измерения Антиматерии",
    id: 0,
    requiredStage: PROGRESS_STAGE.PRE_INFINITY,
    description: `Каждое Измерение Антиматерии непрерывно производит Измерения уровнем ниже. Самое нижнее
      Измерение Антиматерии производит антиматерию.`
  },
  {
    name: "Tickspeed Upgrades",
    textName: "Улучшения Скорости Тика",
    id: 1,
    openH2pEntry: "Tickspeed",
    requiredStage: PROGRESS_STAGE.PRE_INFINITY,
    description: `Улучшения Скорости Тика ускоряют производство Измерений Антиматерии.`
  },
  {
    name: "Autobuyers",
    textName: "АвтоПокупщики",
    id: 2,
    requiredStage: PROGRESS_STAGE.PRE_INFINITY,
    description: `АвтоПокупщики - это встроенная в игру функция, позволяющая покупать улучшения и Измерения Антиматерии
      автоматически, когда у вас накопится достаточно количество ресурсов для покупки.`
  },
  {
    name: "Dimension Boosts",
    textName: "Бусты Измерений",
    id: 3,
    requiredStage: PROGRESS_STAGE.PRE_INFINITY,
    description: `Бусты Измерений зарабатываются за счёт сброса всех Измерений Антиматерии и улучшений скорости тика
      после достижения определённого количество самого высокого доступного Измерения Антиматерии. Они дают множитель к
      Измерениям Антиматерии.`
  },
  {
    name: "Antimatter Galaxies",
    textName: "Галактики Антиматерии",
    id: 4,
    requiredStage: PROGRESS_STAGE.PRE_INFINITY,
    description: `Галактики Антиматерии зарабатываются за счёт сброса Измерений Антиматерии и Бустов Измерений. Они
      улучшают эффективность Улучшений Скорости тика многокомпонентным образом.`
  },
  {
    name: "Infinity",
    textName: "Бесконечность",
    id: 5,
    requiredStage: PROGRESS_STAGE.EARLY_INFINITY,
    description: () => `Бесконечность - первый основной уровень престижа. Достижение ${format(Number.MAX_VALUE, 2)}
      антиматерии позволяет сбросить всё, в обмен на разблокировку нового контента и ресурсов.`
  },
  {
    name: "Infinity Points",
    textName: "Очки Бесконечности",
    id: 6,
    openH2pEntry: "Infinity",
    requiredStage: PROGRESS_STAGE.EARLY_INFINITY,
    description: `Очки Бесконечности - основной ресурс после прохождения первой Бесконечности. Они могут быть потрачены
      на функции, переносящиеся между сбросами Бесконечности.`
  },
  {
    name: "Normal Challenges",
    textName: "Нормальные Челленджи",
    id: 7,
    openH2pEntry: "Normal Challenges",
    requiredStage: PROGRESS_STAGE.EARLY_INFINITY,
    description: () => `Челленджи требуют от вас достигнуть ${format(Number.MAX_VALUE, 2)} антиматерии с более сложными
      условиями. Прохождение Челленджей позволяет вам улучшать АвтоПокупщиков.`
  },
  {
    name: "Break Infinity",
    textName: "Преодоление Бесконечности",
    id: 8,
    requiredStage: PROGRESS_STAGE.BREAK_INFINITY,
    description: () => `Улучшение АвтоПокупщика Большого Хруста до максимума позволяет вам преодлеть
      ${format(Number.MAX_VALUE, 2)} антиматерии, давая увеличивающееся количество Очков Бесконечности с большим
      количеством антиматерии.`
  },
  {
    name: "Infinity Dimensions",
    textName: "Измерения Бесконечности",
    id: 9,
    requiredStage: PROGRESS_STAGE.BREAK_INFINITY,
    description: `Измерения Бесконечности Производятся каскадным образом, подобно Измерениям Антиматерии. Самый
      нижний уровень Измерений Бесконечности производит Мощность Бесконечности, которая даёт огромный множитель
      ко всем Измерениям Антиматерии.`
  },
  {
    name: "Infinity Challenges",
    textName: "Бесконечные Челленджи",
    id: 10,
    requiredStage: PROGRESS_STAGE.BREAK_INFINITY,
    description: () => `Бесконечные Челленджи - новые челленджи с целью антиматерии выше, чем
      ${format(Number.MAX_VALUE, 2)}. Их прохождение награждается улучшениями и бонусами к производству.`
  },
  {
    name: "Replicanti",
    textName: "Репликанты",
    id: 11,
    requiredStage: PROGRESS_STAGE.REPLICANTI,
    description: () => `Репликанты - ресурс, который со временем производит сам себя, давая множитель ко всем
      Измерениям Бесконечности. При ${format(Number.MAX_VALUE, 2)} Репликантов, они могут быть сброшены до
      ${formatInt(1)} для получения дополнительной Галактики, не увеличивающей цену Галактик Антиматерии. Также они
      сбрасываются каждую Бесконечность.`
  },
  {
    name: "Eternity",
    textName: "Вечнсть",
    id: 12,
    requiredStage: PROGRESS_STAGE.EARLY_ETERNITY,
    description: () => `Вечность - второй основной уровень престижа. Достижение ${format(Number.MAX_VALUE, 2)} Очков
      Бесконечности позволяет вам сбросить всё до этого момента для доступа к новому контенту и ресурсам.`
  },
  {
    name: "Eternity Points",
    textName: "Очки Вечности",
    id: 13,
    openH2pEntry: "Eternity",
    requiredStage: PROGRESS_STAGE.EARLY_ETERNITY,
    description: `Очки Вечности - основной ресурс после прохождения вашей первой Вечности. Они масштабируются на основе
      Очков Бесконечности, имеющихся на момент завершения Вечности.`
  },
  {
    name: "Time Studies",
    textName: "Временны́е Исследования",
    id: 14,
    requiredStage: PROGRESS_STAGE.EARLY_ETERNITY,
    description: `Временны́е Исследования - набор улучшений в виде древа улучшений. Их можно свободно перераспределять
      после каждой Вечности без потери ресурсов. Некоторые секции древа имеют ограничения, останавливающие вас
      от одновременного выбора некоторых Исследований.`
  },
  {
    name: "Eternity Milestones",
    textName: "Рубежи Вечности",
    id: 15,
    requiredStage: PROGRESS_STAGE.EARLY_ETERNITY,
    description: `Рубежи Вечности - форма встроенной автоматизаци. Они открываются за прохождение Вечностей.
      Их открытие не требует траты ресурсов.`
  },
  {
    name: "Time Dimensions",
    textName: "Измерения Времени",
    id: 16,
    requiredStage: PROGRESS_STAGE.EARLY_ETERNITY,
    description: `Измерения Времени также производят друг друга в каскадной манере. Наименьший уровень производит
      Осколки Времени. Осколки времени дают дополнительные Улучшения Скорости Тика, которые не увеличивают цену
      Улучшений Скорости Тика, купленных за антиматерию.`
  },
  {
    name: "Eternity Challenges",
    textName: "Вечные Челленджи",
    id: 17,
    requiredStage: PROGRESS_STAGE.ETERNITY_CHALLENGES,
    description: `Вечные Челленджи = изменённые Вечности с целью из Очков Бесконечности, которую необходимо достигнуть
      для прохождения челленджа. Они могут быть пройдены до пяти раз, давая более мощные награды за более сложные
      итерации.`
  },
  {
    name: "Time Dilation",
    textName: "Растяжение Времени",
    id: 18,
    requiredStage: PROGRESS_STAGE.EARLY_DILATION,
    description: () => `Растяжение Времени - изменённая Вечность, в котрой скорость тика и все множители Измерений
      значительно ослаблены. Прохождение Растянутых Вечностей даёт Тахион Частицы.`
  },
  {
    name: "Tachyon Particles",
    textName: "Тахион Частицы",
    id: 19,
    openH2pEntry: "Time Dilation",
    requiredStage: PROGRESS_STAGE.EARLY_DILATION,
    description: () => `Тахион Частицы - ресурс, который не может быть размножен. Они требуют от вас получать
      большее количество антиматерии в Растянутой Вечности для того чтобы увеличить их количество. Тахион Частицы
      производят Растянутое Время.`
  },
  {
    name: "Reality",
    textName: "Реальность",
    id: 20,
    requiredStage: PROGRESS_STAGE.EARLY_REALITY,
    description: () => `Реальность - третий и финальный основной слой престижа. Достижение ${format(DC.E4000)} Очков
      Вечности даёт вам возможность сбросить всё до текущего момента в обмен на разблокировку нового контента и
      доступ к новым ресурсам.`
  },
  {
    name: "Reality Machines",
    textName: "Машины Реальности",
    id: 21,
    openH2pEntry: "Reality",
    requiredStage: PROGRESS_STAGE.EARLY_REALITY,
    description: `Машины Реальности - главный ресурс после прохождения первой Реальности. Они даются на основе
      Очков Вечности на момент прохождения Реальности.`
  },
  {
    name: "Perks",
    textName: "Перки",
    id: 22,
    requiredStage: PROGRESS_STAGE.EARLY_REALITY,
    description: `Перки - разблокируемые возможности, похожие на Рубежи Вечности. Они в основном сфокусированы на
      удобстве и автоматизации. Они покупаются за Очки Перков, которые даются после каждой Реальности.`
  },
  {
    name: "Glyphs",
    textName: "Глифы",
    id: 23,
    requiredStage: PROGRESS_STAGE.EARLY_REALITY,
    description: `Глифы - экипируемые улучшения, которые могут быть сняты только между Реальностями. Каждую Реальность
      вам даётся выбор из множества новых случайных Глифов, которые вы можете получить; среднее качество доступных
      выборов определяется тем, насколько много других ресурсов вы достигли вы этой Реальности.`
  },
  {
    name: "Automator",
    textName: "Автоматизатор",
    id: 24,
    openH2pEntry: "Automator Overview",
    requiredStage: PROGRESS_STAGE.EARLY_REALITY,
    description: `Автоматизатор - встроенная в игру функция, использующая скриптовый язык, позволяющий вам в итоге
      заканчивать Реальности полностью автоматически с достаточным количеством улучшений и перков.`
  },
  {
    name: "Black Hole",
    textName: "Чёрная Дыра",
    id: 25,
    requiredStage: PROGRESS_STAGE.EARLY_REALITY,
    description: `Чёрная Дыра полностью ускоряет игру с некоторой переодичностью. Это влияет на всё в игре до текущего
      момента и будет давать похожие на выход из игры на эквивалентное количество времени результаты.`
  },
  {
    name: "Teresa",
    textName: "Тереза",
    id: 26,
    requiredStage: PROGRESS_STAGE.TERESA,
    description: `Тереза - первое Божество, имеющее более сложную Реальность, дающую значительный бонус к Жертвованию
      Глифов, основываясь на прохождении. Оно разблокирует улучшения, фокусирующиеся на более простом тестировании
      и автоматизации Реальности.`
  },
  {
    name: "Effarig",
    textName: "",
    id: 27,
    requiredStage: PROGRESS_STAGE.EFFARIG,
    description: `Эффариг - второе Божество, чья Реальность ограничивает ваши Глифы и имеет масштабирующиеся ослабления,
       но даёт награды за каждый новый достигнутый слой сброса. Он разблокирует улучшения, фокисирующиеся на
       автоматическом выделении и фильтрации огромного количества получаемых Глифов, купленных с новым ресурсом,
       названным Осколки Реликвий.`
  },
  {
    name: "The Nameless Ones",
    textName: "Безымянные",
    id: 28,
    openH2pEntry: "Nameless Ones",
    requiredStage: PROGRESS_STAGE.ENSLAVED,
    description: `Безымянные - третье Божество, чья Реальность невероятно изнурительна с огромным списком ослаблений,
      однако разблокирует Тессеракты для тех, кто сможет найти способ преодолеть её. Они также модифицируют Чёрные Дыры
      чтобы позвлить вам накапливать время.`
  },
  {
    name: "Stored Time",
    textName: "Накопленне Время",
    id: 29,
    openH2pEntry: "Nameless Ones",
    requiredStage: PROGRESS_STAGE.ENSLAVED,
    description: `Ваша Чёрная Дыра имеет возможность накапливать время двумя способами. Зарядка позволяет задерживать
      ускоренное время, а разрядка создаёт скачок во времени. Накопление реального времени позволяет использовать время
      для симуляции Реальностей (давая умноженные ресурсы данной Реальности), или в качестве дублёра офлайн прогресса.`
  },
  {
    name: "Tesseracts",
    textName: "Тессеракты",
    id: 30,
    requiredStage: PROGRESS_STAGE.ENSLAVED,
    description: `Измерения Бесконечности не могут быть куплены бесконечно, и все, кроме восьмого, имеют жёстко
      установленный лимит на количество раз, которое они могут быть куплены. Каждый Тессеракт навсегда увеличивает
      этот лимит на огромное значение.`
  },
  {
    name: "V",
    textName: "",
    id: 31,
    requiredStage: PROGRESS_STAGE.V,
    description: `Ви - четвёртое Божество, с модифицированной Реальностью, похожей на Реальность Терезы, но дающей
      награды только после достижения определённых рубежей ресурсов внутри. Оно даёт новый ресурс, называемый
      Космические Теоремы, который позволяет вам покупать дополнительные Временны́е Исследования без ограничений путей.`
  },
  {
    name: "Ra",
    textName: "Ра",
    id: 32,
    requiredStage: PROGRESS_STAGE.RA,
    description: `Ра - пятое Божество, с модифицированной Реальностью, производящей ресурс, называемый Куски
      Воспоминаний, основываясь на вашем количестве ресурсов внутри. Оно фокусируется на прокачке предыдущих улучшений
      и тем с предыдущих четырёх Божеств, параллельно заполняя финальные промежутки в автоматизации и удобстве.`
  },
  {
    name: "Memories",
    textName: "Воспоминания",
    id: 33,
    openH2pEntry: "Ra",
    requiredStage: PROGRESS_STAGE.RA,
    description: `Ра контролирует предыдущих четырёх Божеств, со временем производя Воспоминания, основываясь на
      количестве Кусков Памяти. Эти Воспоминания используются для поднятия уровня предыдущих Божеств, давая
      улучшения при достижении определённых уровней.`
  },
  {
    name: "Charged Infinity Upgrades",
    textName: "Заряженные Улучшения Бесконечности",
    id: 34,
    openH2pEntry: "Ra",
    requiredStage: PROGRESS_STAGE.RA,
    description: `Воспоминания Терезы позволяют вам заряжать Улучшения Бесконечности, обеспечивая похожий эффект, но
      значительно усиляя его. Улучшения, которые могут быть заряжены, могут быть изменены между Реальностями..`
  },
  {
    name: "Glyph Alchemy",
    textName: "Алхимия Глифов",
    id: 35,
    requiredStage: PROGRESS_STAGE.RA,
    description: `Воспоминания Эффарига разблокируют Алхимию Глифов, которая даёт множество незначительных бонусов,
      используя модифицированную версию Жертвования Глифов. Ресурсы, заработанные с переработки Глифов таким образом
      соединяются в реакции для того чтобы полностью улучшить их эффект.`
  },
  {
    name: "Amplified Black Hole",
    textName: "Усиленная Чёрная Дыра",
    id: 36,
    openH2pEntry: "Ra",
    requiredStage: PROGRESS_STAGE.RA,
    description: `Воспоминания Безымянных усиливают зарядку таким образом, что количество накапливаемого игрового
      времени становится больше реально прошедшего времени. Разрядка теперь может производиться повторно и
      автоматически.`
  },
  {
    name: "Harder V",
    textName: "Сложный Ви",
    id: 37,
    openH2pEntry: "Ra",
    requiredStage: PROGRESS_STAGE.RA,
    description: `Воспоминания Ви разблокируют модифицированную версию оригинальной Реальности Ви с ещё более сложными
      целями и новым набором Временны́х Исследований, называемым Исследования Триад.`
  },
  {
    name: "Imaginary Machines",
    textName: "Мнимые Машины",
    id: 38,
    requiredStage: PROGRESS_STAGE.IMAGINARY_MACHINES,
    description: () => `Мнимые Машины - новый ресурс, разблокируемый при достежении ${format(DC.E1000)} Машин
      Реальности. Они производятся пассивно до ограничения, определяемого тем, как много Машин Реальности вы бы получили
      в вашей самой далёкой Реальности за всё время.`
  },
  {
    name: "Lai'tela",
    textName: "Лай'тела",
    id: 39,
    requiredStage: PROGRESS_STAGE.LAITELA,
    description: `Лай'тела - шестое Божество, чья Реальность имеет модифицированное условие прохождения и даёт
      масштабирующуюся награду, основывающуюся на том, как быстро вы её достигли. Оно открывает новые возможности,
      в основном относящиеся к ресурсу, называемому Тёмная Материя.`
  },
  {
    name: "Continuum",
    textName: "Континуум",
    id: 40,
    requiredStage: PROGRESS_STAGE.LAITELA,
    description: `Континуум - изменённый тип производства, позволяющий Измерениям Антиматерии производить так, как
      будто они могут купить дробное количество улучшений, без того чтобы в действительности покупать их.`
  },
  {
    name: "Dark Matter Dimensions",
    textName: "Измерения Тёмной Материи",
    id: 41,
    openH2pEntry: "Lai'tela",
    requiredStage: PROGRESS_STAGE.LAITELA,
    description: `Измерения Тёмной Материи - каскадное производство, оперирующее на системе, основанной на тиках, вместо
      продолжительности. Наименьший уровень производит Тёмную Материю и все уровни производят Тёмную Энергию.`
  },
  {
    name: "Dimension Reset Mechanics",
    textName: "Механики Сброса Измерений",
    id: 42,
    openH2pEntry: "Lai'tela",
    requiredStage: PROGRESS_STAGE.LAITELA,
    description: `Измерения Тёмной Материи могут быть сброшены двумя способами. Аннигиляция сбрасывает все ваши
      Измерения в обмен на постоянный множитель ко всем Измерениям Тёмной Материи. Возвышение увеличивает производство,
      но сбрасывает интервал одиночного Измерения.`
  },
  {
    name: "Singularities",
    textName: "Сингулярности",
    id: 43,
    requiredStage: PROGRESS_STAGE.LAITELA,
    description: `Тёмная Энергия может быть использована для производства Сингулярностей, которые дают бонусы
      на основе их общего количества. При производстве Сингулярностей, любая лишняя Тёмная Энергия выше задержки
      уплотнения теряется.`
  },
  {
    name: "Pelle",
    textName: "Пелле",
    id: 44,
    requiredStage: PROGRESS_STAGE.PELLE,
    description: `Пелле - седьмое и финальное Божество, перманентно Обрекающее вашу игру, ставящее вас в очень
      сильно усложнённую модифицированную Реальность, из которой вы не можете выбраться.`
  },
  {
    name: "Armageddon",
    textName: "Армагеддон",
    id: 45,
    openH2pEntry: "Pelle",
    requiredStage: PROGRESS_STAGE.PELLE,
    description: `Армагеддон - специфичный для Пелле сброс, который вы можете совершить в любой момент. Он сбрасывает
      ваш прогресс к началу Обречённой Реальности, но даёт Остатки, производящие Осколки Реальности.`
  },
  {
    name: "Pelle Strikes and Rifts",
    textName: "Удары Пелле и Разломы",
    id: 46,
    openH2pEntry: "Pelle Strikes",
    requiredStage: PROGRESS_STAGE.PELLE,
    description: `После достижения определённых рубежей прогресса внутри Пелле, может случиться Удра, который
      навсегда применяет дополнительные осложнения к Обречённой Реальности. Каждый Удар сопровождается Разломом, который
      является механикой, позволяющей вам расходовать другой ресурс для получения бонусов. Они перманентны и остаются
      разблокированы даже после Армагеддона.`
  },
];
